// src/api/pfSettings.ts
import api from "./api";

export interface PfSettings {
  id: string;
  establishment_id: string | null;
  username: string;
  is_active: boolean;
  // GET never returns the password — this only says whether one is stored.
  has_password: boolean;
  esic_username: string | null;
  has_esic_password: boolean;
  updated_at: string | null;
}

export interface PfSettingsGetResponse {
  settings: PfSettings | null;
}

export interface PfSettingsPayload {
  establishment_id?: string;
  username?: string;
  // Omit to keep the currently stored password unchanged.
  password?: string;
  esic_username?: string;
  // Omit to keep the currently stored ESIC password unchanged.
  esic_password?: string;
}

export interface PfCredentials {
  establishment_id: string | null;
  username: string;
  password: string;
}

export interface PfEcrTextResponse {
  text: string;
}

export const pfSettingsApi = {
  get: () => api.get<PfSettingsGetResponse>(`/pf-settings`),
  save: (payload: PfSettingsPayload) => api.post(`/pf-settings`, payload),
  // Plaintext credentials — only called when handing off to the extension.
  getCredentials: () => api.get<PfCredentials>(`/pf-settings/credentials`),
  // The EPFO ECR return text for one wage month, built from the same
  // approved-payroll data the Statutory report shows — same numbers, just
  // formatted as the '#~#'-delimited file the portal accepts.
  getEcrText: (year: number, month: number) =>
    api.get<PfEcrTextResponse>(`/pf-settings/ecr-text`, { params: { year, month } }),
};
